import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import FileUploadField from '../../FileUploadField';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditAdditionalInsurance = ({ closeModal, id, action, caseId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        case_id: '',
        insurance_company: '',
        contract_number: '',
        date_contract: '',
        date_start: '',
        date_end: '',
        sum_insured: '',
        insurance_premium: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-report?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };
    const handleAssetValueGovChange = (e) => {
        let value = e.target.value;

        // Оставляем только цифры
        value = value.replace(/\D/g, '');

        // Ограничение длины
        if (value.length > 20) value = value.slice(0, 20);

        setFormInfo(prev => ({
            ...prev,
            asset_value: value
        }));
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.insurance_company) {
            newErrors.insurance_company = 'Обязательное поле';
        }
        if (!formInfo.contract_number) {
            newErrors.contract_number = 'Обязательное поле';
        }
        if (!formInfo.date_contract) {
            newErrors.date_contract = 'Обязательное поле';
        }
        if (!formInfo.date_start) {
            newErrors.date_start = 'Обязательное поле';
        }
        if (!formInfo.date_end) {
            newErrors.date_end = 'Обязательное поле';
        }
        if (!formInfo.sum_insured) {
            newErrors.sum_insured = 'Обязательное поле';
        }
        if (!formInfo.insurance_premium) {
            newErrors.insurance_premium = 'Обязательное поле';
        }

        if (!files.insurance) {
            newErrors.files = 'Прикрепите файлы';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('case_id', caseId);
        formData.append('insurance_company', formInfo.insurance_company);
        formData.append('contract_number', formInfo.contract_number);
        formData.append('date_contract', normalizeDate(formInfo.date_contract));
        formData.append('date_start', normalizeDate(formInfo.date_start));
        formData.append('date_end', normalizeDate(formInfo.date_end));
        formData.append('sum_insured', formInfo.sum_insured);
        formData.append('insurance_premium', formInfo.insurance_premium);

        if (files.insurance && files.insurance.length > 0) {
            files.insurance.forEach((file) => {
                formData.append('files_insurance', file);
            });
        }

        axios.put('/api/add-new-case-insurance', formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            },
        })
        .then(() => {
            setStatus(<a>Данные сохранены</a>);
            openTimeModal('Данные успешно сохранены', 'success');
            closeModal();
            onSuccess();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>{error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        });
    };

    const changeData = () => {
        const token = localStorage.getItem('token');

        axios.put(`/api/change-case-insurance`, {
            id: formInfo.id,
            case_id: caseId,
            insurance_company: formInfo.insurance_company,
            contract_number: formInfo.contract_number,
            date_contract: normalizeDate(formInfo.date_contract),
            date_start: normalizeDate(formInfo.date_start),
            date_end: normalizeDate(formInfo.date_end),
            sum_insured: formInfo.sum_insured,
            insurance_premium: formInfo.insurance_premium,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        insurance: null,
    });


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;записи договора дополнительного страхования
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    {/* <div className='labelInputWrapper'>
                        <a className='label'>Балансовая стоимость активов должника по данным управляющего (₽)</a>
                        <div className='labelInputRight'>
                           <input 
                            type='text' 
                            value={formInfo.asset_value} 
                            onChange={handleAssetValueGovChange} 
                            className={errorsForm.asset_value ? 'inputError' : ''}
                            placeholder='' 
                            minLength='' 
                            maxLength='20' 
                            disabled={loading}
                            required />
                            {errorsForm.asset_value && <div className='errorUnderInput'>{errorsForm.asset_value}</div>}
                        </div>
                    </div> */}
                    <div className='labelInputWrapper'>
                        <a className='label'>Страховая компания</a>
                        <div className='labelInputRight'>
                           <input 
                            type='text' 
                            value={formInfo.insurance_company} 
                            onChange={handleChange('insurance_company')} 
                            className={errorsForm.insurance_company ? 'inputError' : ''}
                            placeholder='Полное наименование без сокращений' 
                            minLength='' 
                            maxLength='200' 
                            disabled={loading}
                            required />
                            {errorsForm.insurance_company && <div className='errorUnderInput'>{errorsForm.insurance_company}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер договора</a>
                        <div className='labelInputRight'>
                           <input 
                            type='text' 
                            value={formInfo.contract_number} 
                            onChange={handleChange('contract_number')} 
                            className={errorsForm.contract_number ? 'inputError' : ''}
                            placeholder='' 
                            minLength='' 
                            maxLength='20' 
                            disabled={loading}
                            required />
                            {errorsForm.contract_number && <div className='errorUnderInput'>{errorsForm.contract_number}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата договора</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date_contract?.split('T')[0]}
                                onChange={handleChange('date_contract')} 
                                className={errorsForm.date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_contract && <div className='errorUnderInput'>{errorsForm.date_contract}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата начала</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date?.split('T')[0]}
                                onChange={handleChange('date_start')} 
                                className={errorsForm.date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_start && <div className='errorUnderInput'>{errorsForm.date_start}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата окончания</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date?.split('T')[0]}
                                onChange={handleChange('date_end')} 
                                className={errorsForm.date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date_end && <div className='errorUnderInput'>{errorsForm.date_end}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Страховая сумма (₽)</a>
                        <div className='labelInputRight'>
                           <input 
                            type='text' 
                            value={formInfo.sum_insured} 
                            onChange={handleChange('sum_insured')} 
                            className={errorsForm.sum_insured ? 'inputError' : ''}
                            placeholder='' 
                            minLength='' 
                            maxLength='20' 
                            disabled={loading}
                            required />
                            {errorsForm.sum_insured && <div className='errorUnderInput'>{errorsForm.sum_insured}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Страховая премия (₽)</a>
                        <div className='labelInputRight'>
                           <input 
                            type='text' 
                            value={formInfo.insurance_premium} 
                            onChange={handleChange('insurance_premium')} 
                            className={errorsForm.insurance_premium ? 'inputError' : ''}
                            placeholder='' 
                            minLength='' 
                            maxLength='20' 
                            disabled={loading}
                            required />
                            {errorsForm.insurance_premium && <div className='errorUnderInput'>{errorsForm.insurance_premium}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Файлы</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить файлы'
                                        file={files.insurance}
                                        buttonLabel='Прикрепить файлы'
                                        onChange={(e) => setFiles(prev => ({ ...prev, insurance: Array.from(e.target.files) }))}
                                        onReset={(indexToRemove) =>
                                            setFiles(prev => ({
                                                ...prev,
                                                insurance: prev.insurance.filter((_, i) => i !== indexToRemove),
                                            }))
                                        }
                                        allowMultiple={true}
                                    />
                                    {errorsForm.files && <div className='errorUnderInput'>{errorsForm.files}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файлов у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditAdditionalInsurance;